/* eslint-disable*/
import React, { useEffect, useState } from 'react';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { InfoCircle } from 'react-bootstrap-icons';
import { Controller, useFormContext } from 'react-hook-form';
import * as _MaskedInputModule from 'react-text-mask';
import * as _createNumberMaskModule from 'text-mask-addons/dist/createNumberMask';

import { getComponentFormError } from '../../../utils';
import { convertDecimal } from './cast';

const _rmt: any = (_MaskedInputModule as any).default;
const MaskedInput: any = typeof _rmt === 'function' ? _rmt : _rmt?.default;
const _cnm: any = (_createNumberMaskModule as any).default;
const createNumberMask: (...args: any[]) => any = typeof _cnm === 'function' ? _cnm : _cnm?.default;

const defaultMaskOptions = {
  prefix: '',
  suffix: undefined,
  includeThousandsSeparator: false,
  thousandsSeparatorSymbol: ',',
  allowDecimal: false,
  decimalSymbol: '.',
  decimalLimit: 2,
  allowNegative: false,
  allowLeadingZeroes: false
};

interface Props {
  label: string;
  name: string;
  description?: string;
  allowDecimal?: boolean;
  defaultValue?: number;
  prefix?: string;
  suffix?: string;
  includeThousandsSeparator?: boolean;
  readonly?: boolean;
  onBlur?: any;
  allowNegative?: boolean;
  placeholder?: string;
}

function Number(props: Props) {
  const {
    formState: { errors },
    control,
    setValue,
    getValues
  } = useFormContext();
  const {
    label,
    name,
    description,
    defaultValue,
    prefix,
    allowDecimal,
    includeThousandsSeparator,
    readonly,
    allowNegative,
    placeholder
  } = props;
  const maskOptions = {
    allowDecimal,
    includeThousandsSeparator: includeThousandsSeparator ?? false,
    allowNegative: allowNegative ?? false
  };
  const error = getComponentFormError(name, errors);
  const currencyMask = createNumberMask({
    ...defaultMaskOptions,
    ...maskOptions,
    prefix: prefix ? prefix : ''
  });
  const [thisDefault, setDefault] = useState<number | null>(null);

  useEffect(() => {
    if (defaultValue !== undefined && defaultValue !== null) {
      setDefault(defaultValue);
      setValue(name, defaultValue);
    }
  }, [defaultValue, name, setValue]);

  const handleBlur = () => {
    if (props.onBlur) {
      const value = getValues(name);
      props.onBlur(value);
    }
  };

  return (
    <Form.Group>
      <Form.Label>
        {label}{' '}
        {description ? (
          <OverlayTrigger overlay={<Tooltip id={`tooltip-${name}`}>{description}</Tooltip>}>
            <span className="d-inline-block">
              <InfoCircle className="small"></InfoCircle>
            </span>
          </OverlayTrigger>
        ) : (
          <></>
        )}
      </Form.Label>

      <Controller
        control={control}
        name={name}
        defaultValue={thisDefault}
        render={({ field }) => {
          return (
            <MaskedInput
              placeholder={placeholder}
              mask={currencyMask}
              value={field.value}
              defaultValue={thisDefault as number}
              readOnly={readonly}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const inputValue = e.target.value;

                if (inputValue !== '' && inputValue != undefined) {
                  const newValue = inputValue.replace(/,/g, '');
                  const decimalNumber = convertDecimal(newValue);
                  field.onChange(allowDecimal ? decimalNumber.toFixed(2) : parseInt(newValue));
                } else {
                  field.onChange(null);
                }
              }}
              onBlur={() => {
                if (props.onBlur) {
                  handleBlur();
                }
              }}
              className={
                error
                  ? 'form-control form-control-right  is-invalid'
                  : 'form-control form-control-right'
              }
            />
          );
        }}
      />

      <Form.Control.Feedback type="invalid">{error ? error.message : ''}</Form.Control.Feedback>
    </Form.Group>
  );
}

export default Number;
